import React from "react";
import { Badge } from "@shopify/polaris";
import PrettyDate from "components/format/PrettyDate";
import type { UserSigner } from "types/DokobitMeta";

/**
 * Returns a safe array of contact signers from dokobit/signontab response.
 */
export function getContactSignersArray(
  collection?: UserSigner[]
): UserSigner[] {
  if (collection && collection.length) {
    return collection;
  }
  return [];
}

type TFunction = (key: string) => string;

/**
 * Builds DataTable row arrays for contact signers (name, date, status, optional action cell).
 * Use with Polaris DataTable rows prop; pass columns: 4 for Dokobit (name, date, status, action), 3 for Signontab.
 */
export function renderContactSignerStatuses(
  signers: UserSigner[],
  createdAt: string,
  t: TFunction,
  options?: { columns: 3 | 4 }
): (string | React.ReactNode)[][] {
  return signers.map((signer) => {
    const dateCell = signer.signed ? (
      <PrettyDate dateString={signer.signing_time} showTime={true} />
    ) : (
      <PrettyDate dateString={createdAt || ""} showTime={true} />
    );
    const statusCell = signer.signed ? (
      <Badge tone="success">{t("signed")}</Badge>
    ) : (
      <Badge tone="attention">{t("pending")}</Badge>
    );
    const row: (string | React.ReactNode)[] = [signer.name, dateCell, statusCell];
    if (options?.columns === 4) {
      row.push("");
    }
    return row;
  });
}
